export default "__VITE_ASSET__C$HSqlGP__"